export default "__VITE_ASSET__BS42gCMd__"